// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DummyTable from "../../../molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../../../../pages/ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../../../models/Kkm.js";
import * as Buhta_cabinet__Search from "../../../molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../../molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmMoneyPlacements(Props) {
  let id = Props.id;
  const match = React.useState(function () {
    return 1;
  });
  const setPage = match[1];
  const page = match[0];
  const func = Buhta_cabinet__Kassa.MoneyPlacementService.grid;
  const match$1 = Buhta_core__GrpcState.useGrid((function (param) {
    return Curry._2(func, param, id);
  }), undefined);
  const grid = match$1[0];
  const startCount = Math.imul(25, page - 1 | 0) + (
    typeof grid === "string" || grid.NAME !== "Data" ? 0 : 1
  ) | 0;
  const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
  const count = Math.imul(25, page - 1 | 0) + currentRecords | 0;
  const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */ 0 : Stdlib__List.mapi((function (i, log) {
      const placement_type = Buhta_cabinet__Kkm.MoneyPlacementType.toString(log.placement_type);
      const place_time = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(log.place_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
      const cells_0 = {
        body: placement_type + (MelNumeral.format({
          NAME: "Str",
          VAL: log.amount
        }) + " ₸"),
        style: ""
      };
      const cells_1 = {
        hd: {
          body: "",
          style: ""
        },
        tl: {
          hd: {
            body: place_time,
            style: "justify-end"
          },
          tl: /* [] */ 0
        }
      };
      const cells = {
        hd: cells_0,
        tl: cells_1
      };
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
        cells: cells
      }, Key);
    }), grid.VAL);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Search.make, {
        dispatch: match$1[1],
        page: page,
        setPage: setPage,
        searchLength: 1
      }),
      typeof grid === "string" ? (
          grid === "Loading" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        ) : (
          grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                      header: {
                        hd: {
                          name: "Действие",
                          style: ""
                        },
                        tl: {
                          hd: {
                            name: "Пользователь",
                            style: ""
                          },
                          tl: {
                            hd: {
                              name: "Дата",
                              style: "text-right"
                            },
                            tl: /* [] */ 0
                          }
                        }
                      },
                      rows: rows,
                      styles: "grid-cols-journal-max"
                    }),
                    count <= 0 ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("img", {
                            className: "w-10 h-10",
                            src: StaticAsset.src("/static/icons/cashier-40.svg")
                          }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "mt-6 text-default-gray",
                            children: "Нет записей"
                          })
                        ],
                        className: "flex flex-col items-center col-span-3 mt-84"
                      }) : null
                  ],
                  className: "flex-1 overflow-y-auto"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        children: String(startCount) + ("-" + (String(count) + (" из " + String(count))))
                      }),
                      JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx("img", {
                          className: "ml-4 w-5 h-5",
                          src: StaticAsset.src("/static/icons/back-arrow-black.svg")
                        }),
                        className: "ml-4",
                        onClick: (function (param) {
                          if (page > 1) {
                            return Curry._1(setPage, (function (param) {
                              return page - 1 | 0;
                            }));
                          }
                          
                        })
                      }),
                      JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx("img", {
                          className: "w-5 h-5 rotate-180",
                          src: StaticAsset.src("/static/icons/back-arrow-black.svg")
                        }),
                        className: "ml-2",
                        onClick: (function (param) {
                          if (currentRecords >= 25) {
                            return Curry._1(setPage, (function (param) {
                              return page + 1 | 0;
                            }));
                          }
                          
                        })
                      })
                    ],
                    className: "flex items-center"
                  }),
                  className: "flex justify-end px-6 py-4 border-t border-gray-main"
                })
              ]
            }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        )
    ],
    className: "flex flex-col w-full overflow-y-auto grow"
  });
}

const make = KkmMoneyPlacements;

export {
  make,
}
/* Buhta_cabinet__DummyTable Not a pure module */
